import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__elements-order-number-wrapper';
export class OrderNumber {
    static init($root = $('body')) {
        const $wrappers = $root.find(ELEMENT_SELECTOR);
        if (!$wrappers.length) {
            return;
        }
        this.recalculateOrder($wrappers);
        this.initActions($wrappers);
    }
    static initActions($wrappers) {
        $wrappers.each((index, wrapper) => {
            const $wrapper = $(wrapper);
            const height = $wrapper.height();
            const width = $wrapper.width();
            const config = { attributes: true, childList: true, subtree: true };
            const callback = () => {
                const $orderElement = $(wrapper).find('.js__elements-order-number');
                if ($wrapper.height() != height || $wrapper.width() != width) {
                    $orderElement.each((index, element) => {
                        const $element = $(element);
                        if ($element.text() !== String(index + 1)) {
                            $element.text(index + 1);
                        }
                    });
                }
            };
            const observer = new MutationObserver(callback);
            observer.observe($wrapper.get(0), config);
        });
    }
    static recalculateOrder($wrappers) {
        $wrappers.each((index, wrapper) => {
            const $orderElement = $(wrapper).find('.js__elements-order-number');
            if ($orderElement.length) {
                $orderElement.each((index, element) => {
                    $(element).text(index + 1);
                });
            }
        });
    }
}
